import React from 'react';

import { Button } from 'components/Buttons/Button';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import { ButtonType } from 'enums/ButtonType';
import useAppNavigate from 'hooks/useAppNavigate';

import styles from './Document.module.scss';

interface DocumentProps {
  title: string;
  subtitle?: string;
  handleBack?: (event: any) => void;
  showBackButton?: boolean;
}

const Document = ({
  title,
  subtitle,
  children,
  handleBack,
  showBackButton = true,
}: React.PropsWithChildren<DocumentProps>) => {
  const navigator = useAppNavigate();
  const onBack = async (event: any) => {
    if (handleBack) {
      await handleBack(event);
    } else {
      navigator(-1, { replace: false });
    }
  };

  return (
    <>
      <FormHeader title={title} subtitle={subtitle} classNameWrapper={styles.headerTitle} />
      <FormBody formBodyClassName={styles.formBody}>{children}</FormBody>
      {showBackButton && (
        <div className={styles.buttonContainer}>
          <Button onClick={onBack} buttonType={ButtonType.Secondary} withArrow>
            Back
          </Button>
        </div>
      )}
    </>
  );
};

export default Document;
